import React, {useMemo} from 'react';
import {alpha, Box, Typography} from '@mui/material';
import {ItemTypes} from '../util/itemTypes';

export const ArdDangerBackground = ({
  itemValue,
  itemType,
  isHidden,
  locationLocked
}) => {
  const backgroundImage = useMemo(() => {
    if (itemValue === 'X' || itemValue === 'NaN') return undefined;
    if (itemType !== ItemTypes.DANGER) return undefined;
    return `url("images/ard/icons/danger_${itemValue}.png")`;
  }, [itemValue, itemType, isHidden]);

  return (
    <Box
      sx={theme => ({
        width: '100%',
        height: '70%',
        display: 'flex',
        filter: isHidden ? 'grayscale(100%)' : undefined
      })}>
      {backgroundImage ? (
        <Box
          sx={theme => ({
            width: '100%',
            height: '100%',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundImage,
            border: locationLocked ? 'transparent' : 'dashed 2px white',
            borderRadius: `${theme.shape.borderRadius}px`
          })}
        />
      ) : (
        <Box
          sx={theme => ({
            width: '100%',
            height: '70%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: alpha(theme.palette.grey[500], 0.4),
            borderRadius: `${theme.shape.borderRadius}px`,
            border: locationLocked ? 'transparent' : 'dashed 2px white'
            // backgroundColor: isHidden
            //   ? alpha(theme.palette.grey[500], 0.4)
            //   : 'transparent',
          })}>
          <Typography variant={'body2'}>NO WARN</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ArdDangerBackground;
